import {createAction} from "redux-act";
import {IFanSentimentQuestions} from "apps/DRAW_PREDICTOR/modules/reducers";

export const setFanSentimentsQuestions = createAction<IFanSentimentQuestions[]>();

export const updateFanSentiment =
	createAction<{questionId: number; answerIndex: number; optionId: number}>();
export const saveFanSentiments = createAction();
